import { type CreateInquiryInput, type InquiryAck, type Property, type PropertyCard } from '@resolute/schema';
import { useMutation, useQuery } from '@tanstack/react-query';


import { apiClient, getData } from '@/lib/api-client';

const propertyDetailKeys = {
  detail: (slug: string) => ['property', slug] as const,
  related: (slug: string) => ['property', slug, 'related'] as const,
};

/** Full property detail by slug. */
export function useProperty(slug: string) {
  return useQuery({
    queryKey: propertyDetailKeys.detail(slug),
    queryFn: () => getData<Property>(`/properties/${slug}`),
    enabled: Boolean(slug),
  });
}

/** Related listings for the detail page. */
export function useRelatedProperties(slug: string) {
  return useQuery({
    queryKey: propertyDetailKeys.related(slug),
    queryFn: () => getData<PropertyCard[]>(`/properties/${slug}/related`, { limit: 3 }),
    enabled: Boolean(slug),
  });
}

/** Submit an inquiry / visit / callback (lead capture). */
export function useSubmitInquiry() {
  return useMutation({
    mutationFn: async (input: CreateInquiryInput) => {
      const res = await apiClient.post<{ data: InquiryAck }>('/inquiries', input);
      return res.data.data;
    },
  });
}
